<template>
    <div class="comment-item">
        <img class="comment-item-head" :src="`/api/v1/file/${head}`" alt="">
        <div class="comment-body">
            <div class="comment-name">
                <strong>{{name}}</strong>
                <div class="f-14 color-gray">{{time}}</div>
            </div>
            <el-rate :value="star"
                     disabled
                     show-score
                     disabled-void-color="#cccccc"
                     text-color="#ff9900"
                     style="display: flex;justify-content: flex-start;align-items: center"
                     score-template="{value}"></el-rate>
            <div class="comment-text" v-html="content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CommentItem",
        props: {
            head: {
                type: [String, Number],
                default: ''
            },
            star:{
                type: Number,
                default: 0
            },
            name:{
                type: String,
                default: ''
            },
            text:{
                type: String,
                default: ''
            },
            time:{
                type: String,
                default: ''
            }
        },
        computed:{
            content(){
                return this.text.replace(/\n/g, '<br/>')
            }
        }
    }
</script>

<style scoped lang="less">
    .comment-item{
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        border-top: 1px solid #e2e2e2;
        .comment-item-head{
            width: 50px;
            height: 50px;
            object-fit: cover;
            border-radius: 100%;
            margin-right: 16px;
        }
    }
    .comment-body{
        flex: 1;
    }
    .comment-name{
        width: 100%;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .comment-text{
        font-size: 14px;
        margin: 10px 0;
        text-align: left;
    }
</style>
